
































import auth from '@/auth'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { AddMoneyReq_Type } from '@/apiv3/index'
import helpers from '@/helpers'

@Component({})
export default class FinanceAdd extends Vue {
  public blocked = false
  public amount = ''
  public comment = ''
  public AddMoneyReq_Type = AddMoneyReq_Type

  addMoney (type: AddMoneyReq_Type) {
    this.blocked = true

    if (this.amount === undefined) {
      return
    }

    auth.adminClient().AddMoney({ amount: helpers.getAmount(this.amount), comment: this.comment, type: type }).then(() => {
      this.$router.push('/adm/finance')
    }).finally(() => {
      this.blocked = false
    })
  }
}
